export type FormTypes = {
  dateFrom: string;
  dateTo: string;
  confirmationCode: string;
  authorizationNumber: string;
  memberId: string;
  primaryContactNumber: string;
  memberFirstName: string;
  memberLastName: string;
};

export const defaultValues = {
  dateFrom: '',
  dateTo: '',
  confirmationCode: '',
  authorizationNumber: '',
  memberId: '',
  primaryContactNumber: '',
  memberFirstName: '',
  memberLastName: '',
};
